import { RdfMemorySource } from "../rdf-memory-source.js";
import { fetchRdfQuads } from "../http/http-adapter.js";
import { createSparqlQueryUrl } from "./sparql-adapter.js";
/**
 * Executes a user-defined SPARQL query on a triplestore and provides the
 * results in form of a constant RdfSource.
 */
export class SparqlQueryRdfSource extends RdfMemorySource {
    httpFetch;
    endpoint;
    sparqlQuery;
    format;
    constructor(httpFetch, endpoint, sparqlQuery, format = "text/turtle") {
        super();
        this.httpFetch = httpFetch;
        this.endpoint = endpoint;
        this.sparqlQuery = sparqlQuery;
        this.format = format;
    }
    async query() {
        const query = createSparqlQueryUrl(this.endpoint, this.sparqlQuery, this.format);
        this.quads = await fetchRdfQuads(this.httpFetch, query);
    }
}
//# sourceMappingURL=sparql-query-rdf-source.js.map